import LeadCard
from "./LeadCard";

import Loader
from "../shared/Loader";

import EmptyState
from "../shared/EmptyState";
import { openWhatsapp } from "../../utils/whatsapp";
import { callNumber } from "../../utils/phone";
import Header from "../layout/Header";
import Pagination from "../shared/Pagination";

export default function LeadGrid({

     loading,

    leads,pagination,onPageChange,

    onSelectLead,

    onCreateLead

}){

    if(loading){

        return(

            <Loader/>

        );

    }

    if(!leads.length){

        return(

            <EmptyState

                title="No Leads"

                subtitle="Create your first lead."

                actionText="New Lead"

                onAction={onCreateLead}

            />

        );

    }

    return(
<>
        <div className="crm-lead-grid">

          {

leads.map(

lead=>
<LeadCard

    key={lead.id}

    lead={lead}

    onView={()=>

        onSelectLead(

            lead.id

        )

    }

    onCall={()=>

        callNumber(

            lead.mobile

        )

    }

    onWhatsapp={()=>

        openWhatsapp(

            lead.mobile,

            `Hello ${lead.first_name}, regarding your loan enquiry.`

        )

    }

/>
)}
</div>
<Pagination

    page={pagination?.page}

    totalPages={pagination?.totalPages}

    onChange={onPageChange}

/>

<style>{`.crm-lead-grid{

    display:grid;

    grid-template-columns:repeat(auto-fill,minmax(360px,1fr));

    gap:20px;

}`}</style>
        </>

    );

}